/**
 * Controls full prefetching of logged in home page
 */ export var LOGGED_IN_HOME_PAGE_ROUTE_CHANGE_PREFETCHING_240920 = 'LOGGED_IN_HOME_PAGE_ROUTE_CHANGE_PREFETCHING_240920';
